document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-nav]');
  if (toggle && menu) {
    const close = () => { menu.classList.remove('is-open'); document.body.classList.remove('menu-open'); toggle.setAttribute('aria-expanded', 'false'); };
    toggle.addEventListener('click', () => {
      const open = !menu.classList.contains('is-open');
      menu.classList.toggle('is-open', open);
      document.body.classList.toggle('menu-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    });
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
    document.addEventListener('keyup', event => { if (event.key === 'Escape') close(); });
  }

  document.querySelectorAll('[data-product-form]').forEach(form => {
    const data = form.querySelector('[data-product-variants]');
    const variantInput = form.querySelector('[data-variant-id]');
    const submit = form.querySelector('[data-product-submit]');
    const price = document.querySelector('[data-product-price]');
    if (!data || !variantInput || !submit) return;
    const variants = JSON.parse(data.textContent);
    const groups = [...form.querySelectorAll('[data-option-index]')];
    const selectVariant = () => {
      const selected = groups.map(group => group.querySelector('input:checked')?.value);
      const variant = variants.find(item => item.options.every((value, index) => value === selected[index]));
      if (!variant) {
        submit.disabled = true;
        submit.textContent = 'unavailable';
        return;
      }
      variantInput.value = variant.id;
      if (price) price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(variant.price / 100);
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? submit.dataset.availableLabel : submit.dataset.soldOutLabel;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    groups.forEach(group => group.addEventListener('change', selectVariant));
  });
});
